/**
 * Detects benign Twilio Voice SDK `NotAllowedError` from `setSinkId` in Safari.
 *
 * The SDK calls `HTMLAudioElement.setSinkId()` inside its PeerConnection when a
 * WebRTC track is added. Safari supports `setSinkId` but requires a user gesture
 * to invoke it. Because the SDK calls it from an asynchronous WebRTC callback
 * (outside any gesture context), Safari rejects with a `NotAllowedError`.
 *
 * The call still works — audio plays through the default output device — so this
 * is a benign error that only pollutes error tracking.
 */
export function isTwilioSetSinkIdNoise(
  message: string | undefined,
  stack: string | undefined,
  kind: string | undefined,
): boolean {
  if (!message) {
    return false;
  }

  if (kind !== "NotAllowedError" && !message.includes("NotAllowedError")) {
    return false;
  }

  if (!message.includes("user gesture")) {
    return false;
  }

  if (!stack) {
    return true;
  }

  if (stack.includes("setSinkId")) {
    return true;
  }

  // Datadog may serialize the stack as only the error message with no frames.
  const hasStackFrames = stack
    .split("\n")
    .some((line) => line.trim().startsWith("at "));

  return !hasStackFrames;
}
